import { Worker, Viewer } from '@react-pdf-viewer/core';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.js?url';
import { useEffect } from 'react';

import { Wrapper, ToolbarWrapper } from './PdfViewer.styles';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { PdfToolbar } from '@/pages/Student/Course/components/CurrentActivityViewer/PdfResource/ActivityPdfViewer/PdfToolbar';
import { usePdfResource } from '@/pages/Student/Course/store';

type Props = {
  url: string;
  height?: number | string;
  onPageChange?: (page: number) => void;
  name?: string;
};

const DEFAULT_HEIGHT = 300;

export const PdfViewer: React.FC<Props> = ({
  url,
  height = DEFAULT_HEIGHT,
  onPageChange,
  name
}) => {
  const toolbarPluginInstance = toolbarPlugin();
  const { setViewerRef, viewerRef } = usePdfResource();
  const pageNavigationPluginInstance = pageNavigationPlugin();

  useEffect(() => {
    if (!viewerRef) {
      setViewerRef(pageNavigationPluginInstance);
    }
  }, []);

  return (
    <Worker workerUrl={pdfWorkerUrl}>
      <Wrapper style={{ height, width: '-webkit-fill-available' }}>
        <ToolbarWrapper>
          <PdfToolbar toolbarInstance={toolbarPluginInstance} fileUrl={url} fileName={name} />
        </ToolbarWrapper>
        <Viewer
          fileUrl={url}
          theme={{
            theme: 'dark'
          }}
          plugins={[toolbarPluginInstance, pageNavigationPluginInstance]}
          onPageChange={e => onPageChange?.(e.currentPage)}
        />
      </Wrapper>
    </Worker>
  );
};
